import * as React from 'react';
import { Paper } from '@mui/material';
import { withStyles } from '../../settings/styles';
import { connect } from 'react-redux';
import { AppState } from '../../model/reducers';
import { ThunkDispatch } from 'redux-thunk';
import { loadingOverlay, broadcastMessage } from '../../model/overlay/actions';
import { BroadcastType } from '../../model/overlay/types';
import { NavigationTabProps } from '../../model/navigation/types';
import { withTranslation } from 'react-i18next';

// ----------------- State & Props -----------------  //

interface IState 
{

};

interface IStateProps
{
    
}

interface IDispatchProps
{
    loading: ()=>void;
    doneLoading: ()=>void;
    broadcast: (msg: string, type?: BroadcastType) => void;
}

type Props = NavigationTabProps & IStateProps & IDispatchProps;

// -------------------- Class --------------------  //

class ApiDocsPage extends React.Component<Props, IState> 
{
    constructor(props: any)
    {
        super(props);

        // Init State
        this.state = {

        };

        // Setup Member Functions
        
    }

    render () 
    {
        const { t } = this.props;
        return (
            <Paper sx={{width: "100%", height: "100%"}}>
                <iframe style={{width: "100%", height: "100%", border: 0, borderRadius: "inherit"}} src={`/docs`}></iframe>
            </Paper>
        );
    }
}

// ----------------- Export -----------------  //

const mapStateToProps = (state: AppState, props: NavigationTabProps): IStateProps => ({

});

const mapDispatchToProps = (dispatch: ThunkDispatch<{},{},any>, props: NavigationTabProps): IDispatchProps => ({
    loading: ()=>dispatch(loadingOverlay(true)),
    doneLoading: ()=>dispatch(loadingOverlay(false)),
    broadcast: (msg, type?)=>dispatch(broadcastMessage(msg, type))
});

export default withStyles(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ApiDocsPage)));

// ------------------------------------------  //